import { graphql } from './gql-authz/gql';
/**
 * GraphQL mutation to update the user's preference settings.
 */
export const updateMySettingsGql = graphql(`
  mutation UpdateTheme($theme: Theme!) {
    authz_updateMySettings(theme: $theme) {
      theme
    }
  }
`);
/**
 * GraphQL query to get the user's preference settings.
 */
export const mySettingsGql = graphql(`
  query authz_mySettings {
    authz_mySettings {
      theme
    }
  }
`);
/**
 * GraphQL mutation to update the user's "use new experience" settings.
 */
export const setIsLatestUserInterfaceEnabledGql = graphql(`
  mutation setIsLatestUserInterfaceEnabled(
    $enable: Boolean!
    $userInterface: String
  ) {
    setIsLatestUserInterfaceEnabled(
      enable: $enable
      userInterface: $userInterface
    ) {
      useLatestUserInterface
    }
  }
`);
export const isLatestUserInterfaceEnabledGql = graphql(`
  query isLatestUserInterfaceEnabled($userInterface: String) {
    isLatestUserInterfaceEnabled(userInterface: $userInterface)
  }
`);
